
import { getUnreadTicketsDahboard } from '@/api';
import DatePicker from '@/components/searchPage/DatePicker.vue';
import BackButton from '@/components/UI/backButton/BackButton.vue';
import Button from '@/components/UI/button/Button.vue';
import StopDrawing from '@/components/jobDetailed/StopDrawing/StopDrawing.vue';

import Icon from '@/components/UI/Icon.vue';
import Tooltip from '@/components/UI/Tooltip.vue';
import ToggleButton from '@/components/UI/ToggleButton.vue';
import DateTimezoneToggle from '@/components/UI/dateTimezoneToggle/DateTimezoneToggle.vue';
import ReloadButton from '@/components/UI/ReloadButton.vue';
import TicketSearchField from '@/components/fields/TicketSearchField.vue';

import { User } from '@/models/main';
import { JobTicketDashboardItem, JobTicketDashboardResponse } from '@/models/jobTicket';

import { mapState } from 'vuex';
import { notificationErrorText } from '@/utils/PortalConstants';
import { checkTicketIsRfc } from '@/utils/Common';

import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    BackButton,
    Button,
    DatePicker,
    DateTimezoneToggle,
    Icon,
    ReloadButton,
    StopDrawing,
    ToggleButton,
    Tooltip,
    TicketSearchField,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class AirRoadJobs extends Vue {
  // LOADERS
  public loading = false;
  public loadingSearch = false;

  // USER
  public user!: User;

  // HEADER DATA
  //
  public checkTicketIsRfc = checkTicketIsRfc;

  public ticketStateNames = {
    1: 'new',
    2: 'open',
    3: 'pending reminder',
    4: 'closed',
    5: 'merged',
    6: 'removed',
    7: 'pending close',
  };

  // SEARCH
  public searchValue = '';

  // PAGE DATA
  public pageData: JobTicketDashboardResponse = {
    count: 0,
    next: '',
    previous: '',
    results: [],
  };
  public tableData: JobTicketDashboardItem[] = [];

  public showAll = false;

  public searchBtnClicked() {
    this.loadingSearch = true;
    setTimeout(async () => {
      this.pagination.current = 1;
      await this.getTicketsWrapper();
      this.loadingSearch = false;
    }, 400);
  }

  @Watch('pagination.perPage')
  private perPageSelectChanged() {
    this.pagination.current = 1;
    this.updatePagination();
  }

  // PAGINATION
  public pagination = {
    page: 1,
    current: 1,
    total: 0,
    perPage: '10',
    visible: 7,
    perPageOptions: ['1', '5', '10', '50', '100'],
  };

  // Quick / Single toggle
  public showAllChanged(value: boolean) {
    this.showAll = value;
    this.pagination.current = 1;
    this.getTicketsWrapper();
  }

  public mailStateFilters = {
    closed: true,
    merged: true,
    'pending reminder': true,
    'awaiting dims': true,
    new: true,
    open: true,
  };
  public showRfcOnly = false;

  // State filters
  public async stateFilterClicked(state: string): Promise<void> {
    this.mailStateFilters[state.toLowerCase()] = !this.mailStateFilters[state.toLowerCase()];
    await this.getTicketsWrapper();
  }

  public async rfcFilterClicked(): Promise<void> {
    this.showRfcOnly = !this.showRfcOnly;
    await this.getTicketsWrapper();
  }

  // Navigation:
  //
  // Pagination
  public async updatePagination() {
    await this.getTicketsWrapper();
    // Pagination corrections:
    this.pagination.total = Math.ceil(this.pageData.count / Number(this.pagination.perPage));
    if (this.pagination.current === 0 && this.pagination.total >= 1) {
      this.pagination.current = 1;
    }
    if (this.pagination.current > this.pagination.total) {
      this.pagination.current = this.pagination.total;
    }
  }

  // WRAPPERS
  public async getTicketsWrapper(): Promise<void> {
    this.loading = true;
    this.pageData = { count: 0, next: '', previous: '', results: [] };
    this.tableData = [];
    // Collect state IDs to exclude categories
    const filterIDs: string[] = [];
    Object.keys(this.mailStateFilters).map(filter => {
      if (!this.mailStateFilters[filter]) {
        const filterCode = Object.keys(this.ticketStateNames).find(x => this.ticketStateNames[x] === filter);
        if (filterCode) {
          filterIDs.push(filterCode);
        }
      }
    });
    // Create params object
    const params = {
      page: this.pagination.current,
      page_size: Number(this.pagination.perPage),
      search: this.searchValue,
      exclude_states: filterIDs.join(','),
      ...(this.showRfcOnly && { is_rfc: true }),
    };
    //
    await getUnreadTicketsDahboard(this.showAll, params)
      .then(res => {
        this.tableData = res.results;
        this.pageData = res;
        this.pagination.total = Math.ceil(res.count / Number(this.pagination.perPage));
        this.loading = false;
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error loading AirRoad data',
          text: notificationErrorText,
          type: 'warn',
        });
        this.loading = false;
      });
  }

  private mounted() {
    this.getTicketsWrapper();
  }
}
